import CmtImage from '@coremat/CmtImage';
import GridContainer from '@jumbo/components/GridContainer';
import { Button, Card, Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import ConvertInfoBox from './ConvertInfoBox';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
    backgroundColor: '#000',
    marginBottom: 25,
  },
  qualityCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    backgroundColor: '#C0C5F033',
  },
}));

const ConvertDetails = ({ convertInfo }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <React.Fragment>
      <Card className={classes.cardRoot}>
        <GridContainer>
          <Grid item xs={12} sm={3}>
            <CmtImage src={convertInfo.poster?.large} />
          </Grid>
          <Grid item xs={12} sm={9} style={{ alignSelf: 'center' }}>
            <Card className={classes.cardRoot}>
              <Typography variant="h5">نام فیلم:</Typography>
              <Typography variant="body1">{convertInfo.name}</Typography>
              <Typography variant="h5">نام صاحب اثر:</Typography>
              <Typography variant="body1">{convertInfo.provider_name}</Typography>
            </Card>
          </Grid>
        </GridContainer>
      </Card>
      <GridContainer>
        {convertInfo.download_items?.map(item => (
          <Grid item xs={6} sm={4}>
            <ConvertInfoBox key={item.id} item={item} />
          </Grid>
        ))}
      </GridContainer>
      <Button onClick={() => history.push(`/convert/?movie=${convertInfo.id}`)}>بازگشت به صفحه آپلود</Button>
    </React.Fragment>
  );
};

export default ConvertDetails;
